export const SET_CHANNEL = 'socrates-online/sources/SET_CHANNEL';
export const SET_CHANNELS = 'socrates-online/sources/SET_CHANNELS';
export const SET_CHANNEL_INSURERS = 'socrates-online/sources/SET_CHANNEL_INSURERS';
export const SET_ALL_SCHEMES = 'socrates-online/sources/SET_ALL_SCHEMES';
export const RESET_CHANNEL = 'socrates-online/sources/RESET_CHANNEL';
export const CREATE_CHANNEL = 'socrates-online/source/CREATE_CHANNEL';
export const IS_LOADING = 'socrates-online/source/IS_LOADING';
export const CLEAR_DATA = 'socrates-online/source/CLEAR_DATA';

export const initialState = {
  isSubmitting: false,
  isLoading: false,
  allInsurers: [],
  allSchemes: [],
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_CHANNEL:
      return {
        ...state,
        currentChannel: {
          ...state.resources,
          ...action.data,
        },
      };

    case SET_CHANNELS:
      return {
        ...state,
        channels: {
          ...state.resources,
          ...action.data,
        },
      };

    case SET_CHANNEL_INSURERS:
      return {
        ...state,
        allInsurers: action.data,
      };

    case SET_ALL_SCHEMES:
      return {
        ...state,
        allSchemes: action.data,
      };

    case CREATE_CHANNEL:
      return {
        ...state,
        channels: {
          ...state.resources,
          ...action.data,
        },
      };

    case RESET_CHANNEL:
      return {
        ...state,
        currentChannel: {},
      };

    case IS_LOADING: {
      return {
        ...state,
        isLoading: action.status,
      };
    }
    case CLEAR_DATA: {
      return initialState;
    }

    default:
      return state;
  }
}
